import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import { Helmet } from "react-helmet";


import FormBuilderCustom from "./FormBuilderCustom";
import FormBuilderCustomView from "./FormBuilderCustomView";
import { withNamespaces } from "react-i18next";

import classes from "./FormBuilder.css";

import { logout } from "../../reducers/user/actions";
import isAuthenticated from "../../utils/isAuthenticated";

class FormBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formSchema: {},
    };
  }

  render() {
    const { data, formSchema } = this.state;

    return (
      <div className={classes.wrapper}>
        <Helmet>
          <title>{this.props.i18n.t("Trial Management Portal: Dashboard")}</title>
        </Helmet>
        <div className={classes.parentContainer}>

          <div className={classes.content}>
            <h4 className="headline-default">{this.props.i18n.t("Form builder")}</h4>
            <Row>
              <FormBuilderCustom
                onSubmit={(formSchema) => {
                  this.setState({ formSchema: null }, () => {
                    this.setState({ formSchema });
                  });
                }}
              />
              {formSchema && (
                <FormBuilderCustomView
                  isEditable
                  formSchema={formSchema}
                />
              )}
            </Row>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(FormBuilder))
);



// WEBPACK FOOTER //
// ./src/containers/FormBuilder/FormBuilder.js